var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isPartnerView)?_c('material-overview-partner-view'):_c('material-overview-client-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }